// extracted by mini-css-extract-plugin
export default {"form":"Credentials_form__rcMlt","header":"Credentials_header__CdUYQ","fields-container":"Credentials_fields-container__i7-1q"};